import React from 'react';
import Icon from '../../../components/AppIcon';

const CommissionTracker = ({ data }) => {
  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-heading font-semibold text-foreground mb-2">
            Commission Tracker
          </h2>
          <p className="text-sm text-muted-foreground">
            Earnings breakdown and goal achievement status
          </p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors duration-250">
          <Icon name="Download" size={18} />
          <span className="text-sm font-medium">Export Report</span>
        </button>
      </div>
      <div className="space-y-4">
        {data?.map((staff) => (
          <div key={staff?.staffId} className="bg-muted/50 rounded-lg p-6">
            <div className="flex items-start gap-4 mb-4">
              <img
                src={staff?.avatar}
                alt={staff?.avatarAlt}
                className="w-16 h-16 rounded-full object-cover"
              />
              <div className="flex-1">
                <div className="flex items-center justify-between mb-2">
                  <div>
                    <h3 className="text-lg font-semibold text-foreground">{staff?.name}</h3>
                    <p className="text-sm text-muted-foreground">{staff?.role}</p>
                  </div>
                  <div className="text-right">
                    <div className="text-2xl font-semibold text-foreground data-text">
                      ${staff?.totalCommission?.toLocaleString()}
                    </div>
                    <div className="text-xs text-muted-foreground">Total Commission</div>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                  <div className="bg-card rounded-lg p-3">
                    <div className="flex items-center gap-2 mb-2">
                      <Icon name="Dumbbell" size={16} color="var(--color-primary)" />
                      <span className="text-xs text-muted-foreground">Personal Training</span>
                    </div>
                    <div className="text-lg font-semibold text-foreground data-text">
                      ${staff?.personalTraining?.toLocaleString()}
                    </div>
                  </div>
                  <div className="bg-card rounded-lg p-3">
                    <div className="flex items-center gap-2 mb-2">
                      <Icon name="ShoppingCart" size={16} color="var(--color-success)" />
                      <span className="text-xs text-muted-foreground">Retail Sales</span>
                    </div>
                    <div className="text-lg font-semibold text-foreground data-text">
                      ${staff?.retailSales?.toLocaleString()}
                    </div>
                  </div>
                  <div className="bg-card rounded-lg p-3">
                    <div className="flex items-center gap-2 mb-2">
                      <Icon name="Users" size={16} color="var(--color-accent)" />
                      <span className="text-xs text-muted-foreground">Membership Referrals</span>
                    </div>
                    <div className="text-lg font-semibold text-foreground data-text">
                      ${staff?.membershipReferrals?.toLocaleString()}
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm text-muted-foreground">Goal Progress</span>
                    <span className="text-sm font-semibold text-foreground data-text">{staff?.goalProgress}%</span>
                  </div>
                  <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                    <div
                      className={`h-full transition-all duration-500 ${
                        staff?.goalProgress >= 90 ? 'bg-success' : staff?.goalProgress >= 70 ? 'bg-primary' : 'bg-warning'
                      }`}
                      style={{ width: `${staff?.goalProgress}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommissionTracker;